import { Navigate, Route, Routes } from "react-router-dom";
import Monitoring from "./monitoring";
import ControlTowerAppointmentsRoutes from "./appointments/routes";
import MaintenanceMonitoring from "./maintenanceMonitoring";
import BudgetsV2Page from "./budgets";
import SupportPage from "../../components/support";
import NewSupportCallPage from "../../components/support/newSupportCall";
import SupportDetailsPage from "../../components/support/pages/details";

const ControlTowerRoutes = (props: any) => (
  <Routes>
    <Route path="/" element={<Navigate to="/control-tower/monitoring" />} />
    <Route path="/monitoring" element={<Monitoring {...props} />} />
    <Route
      path="/maintenance-monitoring"
      index
      element={<MaintenanceMonitoring {...props} />}
    />
    <Route
      path="/appointments/*"
      index
      element={<ControlTowerAppointmentsRoutes {...props} />}
    />
    <Route path="/budgets/*" element={<BudgetsV2Page {...props} />} />
    <Route path="/budgets-kanban/*" element={<BudgetsV2Page {...props} />} />
    <Route path="/support" element={<SupportPage {...props} />} />
    <Route path="/support/new-support-call" element={<NewSupportCallPage {...props} />} />
    <Route path="/support/details" element={<SupportDetailsPage {...props} />} />
  </Routes>
);

export default ControlTowerRoutes;
